"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const lodash_1 = require("lodash");
const RecordingGroupsLine = (props) => {
    const { category, recordingGroup } = props;
    const artistString = recordingGroup.artist && recordingGroup.artist.split('|').join(', ');
    return (react_1.default.createElement("li", { className: 'recording-group' },
        recordingGroup.title,
        " by ",
        artistString,
        "\u00A0 (ISRC ",
        recordingGroup.isrc,
        ") Is ",
        (0, lodash_1.capitalize)(category)));
};
exports.default = (0, mobx_react_1.observer)(RecordingGroupsLine);
